(() => {
  const INTERVAL_MS = 4500;

  document.querySelectorAll('[data-incentives-rotator]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-incentive-slide]')];
    if (slides.length <= 1) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer = null;

    const setActive = (index) => {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.toggleAttribute('hidden', i !== index);
      });
      activeIndex = index;
    };

    const advance = () => {
      setActive((activeIndex + 1) % slides.length);
    };

    slides.forEach((slide, i) => {
      if (i !== 0) slide.setAttribute('hidden', '');
    });
    setActive(0);

    if (reducedMotion) return;

    timer = window.setInterval(advance, INTERVAL_MS);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        window.clearInterval(timer);
        timer = null;
      } else if (!timer) {
        timer = window.setInterval(advance, INTERVAL_MS);
      }
    });
  });
})();
